import { createFileRoute } from '@tanstack/react-router'
import SettingsHirist from '@/features/settings/hirist'

export const Route = createFileRoute('/_authenticated/settings/hirist')({
  component: SettingsHirist,
})
